<template>
   <v-container fluid>
      <v-row class="mt-1">
         <v-toolbar dense outlined flat height="80px">
            <v-col cols="6" md="3">
               <v-select
                  v-model="termyearselect"
                  :items="termyear"
                  item-text="termyeartext"
                  item-value="id"
                  label="Select"
                  return-object
                  single-line
                  @change="changeTerm"
               >
               </v-select>
            </v-col>
            <v-col cols="6" md="3" class="mt-2">
               <v-select
                  label="Select Group"
                  :items="yeargroupselect"
                  v-model="selectedyeargroup"
                  return-object
                  @change="changeYearGroup"
               >
               </v-select>
            </v-col>
         </v-toolbar>
      </v-row>
      <v-tabs
         height="50"
         v-model="stattab"
         :slider-color="$globalstore.tab_slidercolor"
         :show-arrows="!$vuetify.breakpoint.mdAndUp"
      >
         <v-tab href="#participant">Group Sign Up</v-tab>
         <v-tab href="#waitlist">Wait List Sign Up </v-tab>
         <v-tab href="#withoutcca">Without CCA</v-tab>
      </v-tabs>
      <v-tabs-items v-model="stattab">
         <v-tab-item :key="1" value="participant">
            <v-row>
               <v-col cols="12" md="12">
                  <v-card flat outlined>
                     <v-text-field
                        class="ml-2 mb-2"
                        v-model="participant_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        clearable
                     ></v-text-field>
                     <v-data-table
                        dense
                        height="55vh"
                        fixed-header
                        :headers="participant_headers"
                        item-key="id"
                        :search="participant_search"
                        single-select
                        :items="participantlist"
                        @click:row="participantRowClick"
                        :items-per-page="itemPageCount"
                        @update:items-per-page="itemPerPageChange"
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
         </v-tab-item>
      </v-tabs-items>
      <v-tabs-items v-model="stattab">
         <v-tab-item :key="2" value="waitlist">
            <v-row>
               <v-col cols="12" md="12">
                  <v-card flat outlined>
                     <v-text-field
                        class="ml-2 mb-2"
                        v-model="waitlist_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                     ></v-text-field>
                     <v-data-table
                        dense
                        height="55vh"
                        fixed-header
                        :headers="waitlist_headers"
                        item-key="id"
                        :search="waitlist_search"
                        single-select
                        :items="waitlist"
                        @click:row="waitlistRowClick"
                        :items-per-page="itemPageCount"
                        @update:items-per-page="itemPerPageChange"
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
         </v-tab-item>
      </v-tabs-items>
      <v-tabs-items v-model="stattab">
         <v-tab-item :key="3" value="withoutcca">
            <v-row>
               <v-col cols="12" md="12">
                  <v-card flat outlined>
                     <v-text-field
                        class="ml-2 mb-2"
                        v-model="withoutcca_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                     ></v-text-field>
                     <v-data-table
                        dense
                        height="55vh"
                        fixed-header
                        :headers="withoutcca_headers"
                        item-key="student_code"
                        :search="withoutcca_search"
                        single-select
                        :items="withoutccalist"
                        @click:row="withoutCCARowClick"
                        :items-per-page="itemPageCount"
                        @update:items-per-page="itemPerPageChange"
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
         </v-tab-item>
      </v-tabs-items>
      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "../components/ConfirmDlg.vue";
   import ShowToast from "../components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {ConfirmDlg, ShowToast},
      data() {
         return {
            termyearselect: null,
            termyear: [],
            stattab: "",
            itemPageCount: this.$globalstore.ccagroup.itemsperpage || 10,
            yeargroupselect: [
               {
                  id: 1,
                  text: "Preschool",
                  yeargroup: [-1, 0],
               },
               {
                  id: 2,
                  text: "Primary",
                  yeargroup: [1, 2, 3, 4, 5, 6],
               },
               {
                  id: 3,
                  text: "Secondary",
                  yeargroup: [7, 8, 9, 10, 11, 12, 13],
               },
            ],
            allyeargroup: [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            selectedyeargroup: null,
            participant_search: "",
            participantlist: [],
            participant_headers: [
               {
                  text: "CCA Name",
                  value: "cca_name",
                  width: "230px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Day Time",
                  value: "daytime",
                  width: "110px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  width: "90px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Code",
                  value: "student_code",
                  width: "80px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "fullname",
                  width: "250px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Form",
                  value: "yearform",
                  width: "80px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Type",
                  value: "subtypetext",
                  width: "60px",
                  sortable: false,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Consent",
                  value: "consentstatustext",
                  width: "110px",
                  sortable: false,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Sign Up Date",
                  value: "signupdate",
                  width: "150px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            waitlist_search: "",
            waitlist: [],
            waitlist_headers: [
               {
                  text: "CCA Name",
                  value: "cca_name",
                  width: "230px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Day Time",
                  value: "daytime",
                  width: "120px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  width: "90px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Code",
                  value: "student_code",
                  width: "80px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "fullname",
                  width: "250px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Form",
                  value: "yearform",
                  width: "80px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Type",
                  value: "subtypetext",
                  width: "60px",
                  sortable: false,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Consent",
                  value: "consentstatustext",
                  width: "110px",
                  sortable: false,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Sign Up Date",
                  value: "signupdate",
                  width: "150px",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            withoutcca_search: "",
            withoutccalist: [],
            withoutcca_headers: [
               {
                  text: "Code",
                  value: "student_code",
                  width: "15%",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "fullname",
                  width: "55%",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Year",
                  value: "yeargrouptext",
                  width: "15%",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Form",
                  value: "yearform",
                  width: "15%",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },

      methods: {
         itemPerPageChange(count) {
            this.$globalstore.ccastatistic.itemsperpage = count;
         },

         participantRowClick(item, row) {
            row.select(!row.isSelected);
         },

         waitlistRowClick(item, row) {
            row.select(!row.isSelected);
         },

         withoutCCARowClick(item, row) {
            row.select(!row.isSelected);
         },

         changeTerm(yearterm) {
            if (yearterm) {
               this.$globalstore.currentyear = yearterm.year;
               this.$globalstore.currentterm = yearterm.term;

               this.reloadAllList();
            }
         },

         changeYearGroup() {
            if (this.selectedyeargroup) {
               this.$globalstore.ccastatistic.yeargroup = Object.assign({}, this.selectedyeargroup);
               this.reloadAllList();
            }
         },

         async loadParticipantList() {
            await this.$http({
               url: "/cca/getparticipant_sublist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.termyearselect.year,
                  cca_term: this.termyearselect.term,
                  yeargroup: this.selectedyeargroup
                     ? this.selectedyeargroup.yeargroup
                     : this.allyeargroup,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.participantlist = response.data.participantdata;
                  }
               }
            });
         },

         async reloadAllList() {
            await this.loadParticipantList();
            await this.loadWaitList();
            await this.loadWithoutCCAList();
         },

         async loadWaitList() {
            await this.$http({
               url: "/cca/getwait_sublist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.termyearselect.year,
                  cca_term: this.termyearselect.term,
                  yeargroup: this.selectedyeargroup
                     ? this.selectedyeargroup.yeargroup
                     : this.allyeargroup,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.waitlist = response.data.waitlistdata;
                  }
               }
            });
         },

         async loadWithoutCCAList() {
            await this.$http({
               url: "/cca/getwithoutccalist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.termyearselect.year,
                  cca_term: this.termyearselect.term,
                  yeargroup: this.selectedyeargroup
                     ? this.selectedyeargroup.yeargroup
                     : this.allyeargroup,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.withoutccalist = response.data.withoutccadata;
                  }
               }
            });
         },

         SetTermYear() {
            if (this.$globalstore.currentyear && this.$globalstore.currentterm) {
               this.termyearselect = this.termyear.find(
                  (x) =>
                     x.year == this.$globalstore.currentyear &&
                     x.term == this.$globalstore.currentterm
               );
            } else {
               this.termyearselect = this.termyear.find(
                  (x) => x.id == this.$globalstore.appsettings.currentyearterm.id
               );
            }
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.stattab = "participant";
            this.termyear = this.$globalstore.termyearlist;
            this.SetTermYear();
            await this.loadParticipantList();
            await this.loadWaitList();
            await this.loadWithoutCCAList();
            if (this.$globalstore.ccastatistic.itemsperpage) {
               this.itemPageCount = this.$globalstore.ccastatistic.itemsperpage;
            }
         }
      },
   };
</script>
